<template>
    <pharmacists-dialog
        v-model="isOpen"
        title="Freiberufler Negativ-Liste bearbeiten"
        :activePharmacists="activePharmacists"
        :savedPharmacistIds="blacklistIds"
        @save="submit"
    />
</template>

<script>
import axios from "axios";
import { mapMutations } from 'vuex';
import PharmacistsDialog from "./PharmacistsDialog.vue";

export default {
    props: {
        value: Boolean,
        activePharmacists: Array,
        pharmacyId: String,
        blacklistIds: Array
    },
    components: {
        PharmacistsDialog
    },
    emits: ['get-pharmacists'],
    data: function() {
        return {
            selectedPharmacistIds: [...this.blacklistIds],
        };
    },
    methods: {
        async submit(selectedPharmacistIds) {
            try {
                const response = await axios.post(`/pharmacies/${this.pharmacyId}/contractor_blacklist`, {
                    contractor_ids: selectedPharmacistIds
                });
                if (response.data[1] == 200) this.alertSuccess(response.data[0].message);
                this.isOpen = false;
                this.$emit('get-pharmacists');
            } catch(e) {
                this.alertError(e)
            }
        },
        ...mapMutations({
            alertError: 'alert/error',
            alertSuccess: 'alert/success'
        })
    },
    computed: {
        isOpen: {
            get() {
                return this.value
            },
            set(state) {
                this.$emit('input', state)
            }
        },
    },
}
</script>

<style scoped>
.list-group-item {
    padding: 8x 15px;
}
</style>
